import { erpAxios } from '..';

const deleteSuduznik = async (id) => {
  const res = await erpAxios.delete(`/suduznici/${id}`);
  return res;
};

export default deleteSuduznik;
